(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["filters"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('rsp-collection-filter-toggle')) {
    customElements.define(
      'rsp-collection-filter-toggle',
      class RSPCollectionFilterToggle extends HTMLElement {
        connectedCallback() {
          if (this.initialized) return;
          this.initialized = true;
          this.button = this.querySelector('button');
          this.label = this.querySelector('[data-rsp-filter-label]');
          this.wrapper = this.closest('.collection-wrapper');

          if (!this.button || !this.label || !this.wrapper) return;

          try {
            this.hidden = sessionStorage.getItem('rsp-collection-filters-hidden') === 'true';
          } catch {
            this.hidden = false;
          }
          this.render();
          this.button.addEventListener('click', () => {
            this.hidden = !this.hidden;
            try {
              sessionStorage.setItem('rsp-collection-filters-hidden', String(this.hidden));
            } catch {
              // The visual toggle still works if storage is unavailable.
            }
            this.render();
          });
        }

        render() {
          this.wrapper.classList.toggle('rsp-filters-hidden', this.hidden);
          this.button.setAttribute('aria-expanded', String(!this.hidden));
          this.label.textContent = this.hidden ? 'Show filters' : 'Hide filters';
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
